




































import { defineComponent } from '@vue/composition-api';
import TrButton from '@front-app/components/buttons/TrButton.vue';

export default defineComponent({
	components: { TrButton },
	props: {
		isSelected: Boolean,
		isHovered: Boolean,
		isDark: Boolean,
		button: Boolean,
		tag: {
			type: String,
			default: 'button',
		},
	},
});
